module.exports = __webpack_public_path__ + "img/logo-alt.a8a205e.png";